/* tslint:disable */
/* eslint-disable */
/**
 * livechat
 * livechat API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ChatPricingSettingsOut } from '../models';
// @ts-ignore
import type { ChatPricingSettingsUpdate } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { OrganizationOut } from '../models';
/**
 * ChatPricingSettingsApi - axios parameter creator
 * @export
 */
export const ChatPricingSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all chat pricing settings.
         * @param {string | null} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChatPricingSettings: async (organizationId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/chat-pricing-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganizationsPricing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat-pricing-settings/pricing/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pricing settings by organization_id.
         * @param {string | null} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingByOrganization: async (organizationId?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/chat-pricing-settings/pricing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (organizationId !== undefined) {
                localVarQueryParameter['organization_id'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add, update, or edit chat pricing settings.
         * @param {ChatPricingSettingsUpdate} chatPricingSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertChatPricingSettings: async (chatPricingSettingsUpdate: ChatPricingSettingsUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'chatPricingSettingsUpdate' is not null or undefined
            assertParamExists('upsertChatPricingSettings', 'chatPricingSettingsUpdate', chatPricingSettingsUpdate)
            const localVarPath = `/api/v1/chat-pricing-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chatPricingSettingsUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChatPricingSettingsApi - functional programming interface
 * @export
 */
export const ChatPricingSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChatPricingSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all chat pricing settings.
         * @param {string | null} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllChatPricingSettings(organizationId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatPricingSettingsOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllChatPricingSettings(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPricingSettingsApi.getAllChatPricingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOrganizationsPricing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOrganizationsPricing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPricingSettingsApi.getAllOrganizationsPricing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pricing settings by organization_id.
         * @param {string | null} [organizationId] Organization ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPricingByOrganization(organizationId?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ChatPricingSettingsOut>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPricingByOrganization(organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPricingSettingsApi.getPricingByOrganization']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Add, update, or edit chat pricing settings.
         * @param {ChatPricingSettingsUpdate} chatPricingSettingsUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertChatPricingSettings(chatPricingSettingsUpdate: ChatPricingSettingsUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChatPricingSettingsOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertChatPricingSettings(chatPricingSettingsUpdate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChatPricingSettingsApi.upsertChatPricingSettings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChatPricingSettingsApi - factory interface
 * @export
 */
export const ChatPricingSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChatPricingSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all chat pricing settings.
         * @param {ChatPricingSettingsApiGetAllChatPricingSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllChatPricingSettings(requestParameters: ChatPricingSettingsApiGetAllChatPricingSettingsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatPricingSettingsOut>> {
            return localVarFp.getAllChatPricingSettings(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all organizations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOrganizationsPricing(options?: RawAxiosRequestConfig): AxiosPromise<Array<OrganizationOut>> {
            return localVarFp.getAllOrganizationsPricing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pricing settings by organization_id.
         * @param {ChatPricingSettingsApiGetPricingByOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPricingByOrganization(requestParameters: ChatPricingSettingsApiGetPricingByOrganizationRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<ChatPricingSettingsOut>> {
            return localVarFp.getPricingByOrganization(requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add, update, or edit chat pricing settings.
         * @param {ChatPricingSettingsApiUpsertChatPricingSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertChatPricingSettings(requestParameters: ChatPricingSettingsApiUpsertChatPricingSettingsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ChatPricingSettingsOut> {
            return localVarFp.upsertChatPricingSettings(requestParameters.chatPricingSettingsUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getAllChatPricingSettings operation in ChatPricingSettingsApi.
 * @export
 * @interface ChatPricingSettingsApiGetAllChatPricingSettingsRequest
 */
export interface ChatPricingSettingsApiGetAllChatPricingSettingsRequest {
    /**
     * 
     * @type {string}
     * @memberof ChatPricingSettingsApiGetAllChatPricingSettings
     */
    readonly organizationId?: string | null
}

/**
 * Request parameters for getPricingByOrganization operation in ChatPricingSettingsApi.
 * @export
 * @interface ChatPricingSettingsApiGetPricingByOrganizationRequest
 */
export interface ChatPricingSettingsApiGetPricingByOrganizationRequest {
    /**
     * Organization ID
     * @type {string}
     * @memberof ChatPricingSettingsApiGetPricingByOrganization
     */
    readonly organizationId?: string | null
}

/**
 * Request parameters for upsertChatPricingSettings operation in ChatPricingSettingsApi.
 * @export
 * @interface ChatPricingSettingsApiUpsertChatPricingSettingsRequest
 */
export interface ChatPricingSettingsApiUpsertChatPricingSettingsRequest {
    /**
     * 
     * @type {ChatPricingSettingsUpdate}
     * @memberof ChatPricingSettingsApiUpsertChatPricingSettings
     */
    readonly chatPricingSettingsUpdate: ChatPricingSettingsUpdate
}

/**
 * ChatPricingSettingsApi - object-oriented interface
 * @export
 * @class ChatPricingSettingsApi
 * @extends {BaseAPI}
 */
export class ChatPricingSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get all chat pricing settings.
     * @param {ChatPricingSettingsApiGetAllChatPricingSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPricingSettingsApi
     */
    public getAllChatPricingSettings(requestParameters: ChatPricingSettingsApiGetAllChatPricingSettingsRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatPricingSettingsApiFp(this.configuration).getAllChatPricingSettings(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all organizations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPricingSettingsApi
     */
    public getAllOrganizationsPricing(options?: RawAxiosRequestConfig) {
        return ChatPricingSettingsApiFp(this.configuration).getAllOrganizationsPricing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pricing settings by organization_id.
     * @param {ChatPricingSettingsApiGetPricingByOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPricingSettingsApi
     */
    public getPricingByOrganization(requestParameters: ChatPricingSettingsApiGetPricingByOrganizationRequest = {}, options?: RawAxiosRequestConfig) {
        return ChatPricingSettingsApiFp(this.configuration).getPricingByOrganization(requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add, update, or edit chat pricing settings.
     * @param {ChatPricingSettingsApiUpsertChatPricingSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChatPricingSettingsApi
     */
    public upsertChatPricingSettings(requestParameters: ChatPricingSettingsApiUpsertChatPricingSettingsRequest, options?: RawAxiosRequestConfig) {
        return ChatPricingSettingsApiFp(this.configuration).upsertChatPricingSettings(requestParameters.chatPricingSettingsUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}

